import React, { useState } from 'react';
import { SideSheetBody, SideSheetContentCol, Box, SideSheetFooter, ButtonSize, ButtonAppearance } from '@bechtel/gds';
import {
  DrawerBackdropStyled,
  DrawerOuterStyled,
  DrawerHeaderStyled,
  DrawerCloseStyled,
  ButtonBox,
  TabListStyled,
  TabButtonStyled,
} from './styled';
import { UnderConstruction } from '~/components/atoms/under-construction';
import { ErrorBoundary } from '~/components/atoms/error-boundary';
import { DrawerFooterButtonStyled } from '~/components/ions/drawer';
import { t, Trans } from '@lingui/macro';
import { SettingsTab } from './types';
import { DisplaySettings } from './display-settings';
import { languageList, Lang } from './form-data';

export const Settings = ({ close, onSelectLanguage }) => {
  const [selectedTab, setSelectedTab] = useState<SettingsTab>(SettingsTab.DISPLAY_SETTINGS);
  const [userLanguage, setUserLanguage] = useState<Lang>(languageList[0]);
  return (
    <DrawerBackdropStyled>
      <DrawerOuterStyled>
        <DrawerHeaderStyled title={t`My Settings`}>
          <DrawerCloseStyled onClick={close}></DrawerCloseStyled>
        </DrawerHeaderStyled>
        <SideSheetBody>
          <ErrorBoundary>
            <SideSheetContentCol>
              <TabListStyled>
                <TabButtonStyled
                  isSelected={selectedTab === SettingsTab.TUTORIALS}
                  key={SettingsTab.TUTORIALS}
                  onClick={() => setSelectedTab(SettingsTab.TUTORIALS)}
                >
                  <Trans>Tutorials</Trans>
                </TabButtonStyled>
                <TabButtonStyled
                  key={SettingsTab.DISPLAY_SETTINGS}
                  isSelected={selectedTab === SettingsTab.DISPLAY_SETTINGS}
                  onClick={() => setSelectedTab(SettingsTab.DISPLAY_SETTINGS)}
                >
                  <Trans>Display Settings</Trans>
                </TabButtonStyled>
                <TabButtonStyled
                  key={SettingsTab.NOTIFICATIONS}
                  isSelected={selectedTab === SettingsTab.NOTIFICATIONS}
                  onClick={() => setSelectedTab(SettingsTab.NOTIFICATIONS)}
                >
                  <Trans>Notifications</Trans>
                </TabButtonStyled>
                <TabButtonStyled
                  key={SettingsTab.CONTACT}
                  isSelected={selectedTab === SettingsTab.CONTACT}
                  onClick={() => setSelectedTab(SettingsTab.CONTACT)}
                >
                  <Trans>Contact</Trans>
                </TabButtonStyled>
              </TabListStyled>
              {selectedTab === SettingsTab.DISPLAY_SETTINGS && (
                <ErrorBoundary>
                  <DisplaySettings
                    languageList={languageList}
                    userLanguage={userLanguage}
                    setUserLanguage={setUserLanguage}
                  />
                </ErrorBoundary>
              )}
              {selectedTab !== SettingsTab.DISPLAY_SETTINGS && (
                <Box mx={{ sm: '800' }} my={{ sm: '900' }}>
                  <UnderConstruction />
                </Box>
              )}
            </SideSheetContentCol>
          </ErrorBoundary>
        </SideSheetBody>
        <SideSheetFooter>
          {selectedTab == SettingsTab.DISPLAY_SETTINGS && (
            <ButtonBox>
              <Box mr={{ sm: '400' }}>
                <DrawerFooterButtonStyled
                  size={ButtonSize.MEDIUM}
                  appearance={ButtonAppearance.SECONDARY}
                  onClick={close}
                >
                  &nbsp;<Trans>Cancel</Trans>&nbsp;
                </DrawerFooterButtonStyled>
              </Box>
              <Box>
                <DrawerFooterButtonStyled
                  type="submit"
                  size={ButtonSize.MEDIUM}
                  appearance={ButtonAppearance.SECONDARY}
                  onClick={(e) => {
                    onSelectLanguage(userLanguage);
                  }}
                >
                  <Trans>Apply Changes</Trans>
                </DrawerFooterButtonStyled>
              </Box>
            </ButtonBox>
          )}
        </SideSheetFooter>
      </DrawerOuterStyled>
    </DrawerBackdropStyled>
  );
};
